var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TabsCards',{attrs:{"tabs":_vm.tabsData},on:{"change":_vm.selectTab}}),_c('v-row',{staticClass:"row-cards"},[_c('ChartCard',{attrs:{"sizes":{
        default: 12
      },"chart":_vm.chart,"customOptions":_vm.customOptions,"visibleCard":""}})],1),_vm._t("default",function(){return [(_vm.displayChart)?_c('v-row',{staticClass:"row-cards"},[_c('Table',{attrs:{"loading":_vm.table.loading,"items":_vm.table.data,"fields":_vm.getHeader,"visibleCard":""}})],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }